import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { TaskType } from './taskType.model';

const axios = useAxios();

export interface TaskTypeService {
  Fetch: () => Promise<AxiosResponse<TaskType[]>>;
}

const Fetch = (): Promise<AxiosResponse<TaskType[]>> => axios.Get<TaskType[]>('/api/tasktypes');

export default { Fetch } as TaskTypeService;
